import { Box, Grid, IconButton, Typography } from '@material-ui/core';
import {
  CoverageCatalog,
  CoverageCatalogResume,
  QuotationUnit,
} from 'data-layer-cr/dist/models';
import { colors } from 'design-system';
import { useState } from 'react';
import { HelpCircle } from 'react-feather';
// hooks
import { useCoverageData } from 'src/hooks/useCoverageData';
// models
import { faHandHoldingCircleDollar } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ExemptionCoverageId } from 'src/components/screens/Quotations/components/IndividualCoverages/ExemptionCoverage';
import DeductibleHelpModal from 'src/components/screens/Quotations/components/IndividualDeductibles/DeductibleHelpModal';
import InformationRow from 'src/components/screens/Quotations/components/IndividualDeductibles/InformationRow';

type Props = {
  unit: QuotationUnit;
  coverageCatalogs: CoverageCatalog[];
  moneyType: string | undefined;
  coverageCatalogResumes: CoverageCatalogResume[];
  packageOption: number;
  createdAt: string;
};

const IndividualDeductibleResumeCard = ({
  coverageCatalogs,
  coverageCatalogResumes,
  unit,
  moneyType,
  packageOption,
  createdAt,
}: Props): JSX.Element => {
  const [openModal, setOpenModal] = useState(false);
  const { deductibleResume } = useCoverageData({
    moneyType,
    coverageCatalogs,
    unit,
    coverageCatalogResumes,
    packageOption: packageOption + 1,
    createdAt,
  });

  return (
    <>
      <Box data-testid="individual-deductibles-card">
        <Grid container justifyContent="space-between">
          <Box display="flex" style={{ gap: '0.5rem' }}>
            <FontAwesomeIcon
              icon={faHandHoldingCircleDollar}
              size="2xl"
              color="#0D2E68"
            />
            <Typography
              data-testid="title-text"
              style={{ fontSize: '19px', fontWeight: 700 }}
            >
              Deducibles
            </Typography>
          </Box>
          <Box>
            <IconButton
              data-testid="helper-button"
              onClick={() => setOpenModal(true)}
            >
              <HelpCircle size={24} color={colors.bright_turquoise} />
            </IconButton>
          </Box>
        </Grid>
        <Box
          display="flex"
          flexDirection="column"
          marginTop="1rem"
          style={{ gap: '1rem' }}
        >
          {deductibleResume
            .filter((item) => item.code !== ExemptionCoverageId)
            .map(({ code, name, value, helperText, showHelper }) => (
              <InformationRow
                data-testid={`deductible-${code}`}
                key={code}
                description={name}
                value={value}
                helperText={helperText}
                showHelper={showHelper}
              />
            ))}
        </Box>
      </Box>
      <DeductibleHelpModal
        data-testid="deductible-help-modal"
        open={openModal}
        onCloseModal={() => setOpenModal(false)}
      />
    </>
  );
};

export default IndividualDeductibleResumeCard;
